import gql from 'graphql-tag';

export const createReminderRuleMutation = gql`
  mutation createReminderRule($reminderRule: InputCreateReminderRule!) {
    createReminderRule(reminderRule: $reminderRule) {
      id
      createdAt
      updatedAt
      createdBy
      updatedBy
      groupId
      teamId
      action
      target
      order
      name
      triggerTiming
      triggerTime
      triggerStatuses
      deletedAt
    }
  }
`;
